import { MeiliSearch } from 'meilisearch';
import { config } from '../../../../config/config';
import { MeiliIndex, SearchDatabaseResult, SearchDatabaseResultItem } from './types';
import { SEARCH_RESULTS_MAX } from './consts';

const createSearchClient = () => {
  const host = config.meilisearchHost;
  const apiKey = config.meilisearchApiKey;

  return new MeiliSearch({
    host,
    apiKey,
  });
};

export const doMeiliSearch = async (
  value: string,
  queryTypes: MeiliIndex[]
): Promise<SearchDatabaseResult[] | null> => {
  if (!value.trim()) {
    return [];
  }

  try {
    const searchClient = createSearchClient();
    const hitsPerPage = Math.ceil(SEARCH_RESULTS_MAX / queryTypes.length);

    const response = await searchClient.multiSearch({
      queries: queryTypes.map((type) => ({
        indexUid: type,
        q: value,
        limit: hitsPerPage,
      })),
    });

    return response.results.map((res, index) => {
      const currentType = queryTypes[index];
      if (!currentType) {
        throw new Error('Query type not found for index');
      }
      return {
        type: currentType,
        items: res.hits.map((hit) => ({
          item: hit,
          type: currentType,
        })) as SearchDatabaseResultItem[],
      };
    });
  } catch (error) {
    console.error('MeiliSearch error:', error);
    return null;
  }
};
